import { formatDate } from "@amber/ui";
import type { SpeakerView } from "../contracts/index";

const pad = (n: number) => String(n).padStart(2, "0");

export function clock(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return h > 0 ? `${String(h)}:${pad(m)}:${pad(s % 60)}` : `${pad(m)}:${pad(s % 60)}`;
}

export function percent(value: number | null): string {
  return value === null ? "unknown" : value.toFixed(2);
}

export const LANGUAGE_NAMES: Record<string, string> = { en: "English", de: "German" };

export function languageName(code: string | null): string {
  return code ? (LANGUAGE_NAMES[code] ?? code.toUpperCase()) : "Unknown";
}

export const LANE_COLORS = [
  "bg-link",
  "bg-done",
  "bg-waiting",
  "bg-[color-mix(in_srgb,var(--color-link)_55%,var(--color-done))]",
  "bg-[color-mix(in_srgb,var(--color-waiting)_60%,var(--color-link))]",
] as const;
export const LANE_DOTS = ["text-link", "text-done", "text-waiting", "text-link", "text-waiting"] as const;

export function laneColor(lane: number, unresolved: boolean): string {
  return unresolved ? "bg-muted/60" : (LANE_COLORS[lane % LANE_COLORS.length] ?? "bg-link");
}

export function checksFact(c: { verified: number; failed: number; rechecking: number }): string {
  if (c.verified + c.failed + c.rechecking === 0) return "None requested";
  return `${String(c.verified)} verified · ${String(c.failed)} failed${c.rechecking > 0 ? ` · ${String(c.rechecking)} rechecking` : ""}`;
}

export const EVIDENCE_ERROR_FALLBACK = "Something went wrong. Try again.";

export const REQUIRED_REASON = { minLength: 1, message: "A reason is required" };

export function capacityText(c: NonNullable<SpeakerView["capacity"]>): string {
  const held = [c.role, c.affiliation].filter((v): v is string => v !== null).join(" · ");
  const on = c.date ? ` (${formatDate(c.date)})` : "";
  return held ? `At the time${on}: ${held}` : `${c.note ?? "Role at the time unknown"}${on}`;
}
